/**
 * Enumerates the available public categorization schemes.
 *
 * @remarks
 * Each scheme is represented by a unique numeric identifier.
 *
 * @enum {number}
 * @property {number} APTITUDE - Represents the Aptitude categorization scheme.
 * @property {number} CC - Represents the CC categorization scheme.
 * @property {number} UNSPSC - Represents the UNSPSC categorization scheme.
 */
export enum PublicCategorizationSchemes {
  APTITUDE = 3324976885,
  CC = 3255192198,
  UNSPSC = 3255570485,
}
